(() => {
  const body = document.body
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  const videos = Array.from(document.querySelectorAll(".fs-blissy video"))

  const openFunnel = () => {
    body.classList.add("fs-blissy-funnel-open")
    window.requestAnimationFrame(() => {
      document.querySelector("#dtfs-fs-question")?.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" })
    })
  }

  document.addEventListener("click", event => {
    if (event.target.closest(".fs-blissy [data-fs-funnel-cta]")) openFunnel()
  })

  if (reducedMotion) {
    videos.forEach(video => video.pause())
    return
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target
      if (entry.isIntersecting) video.play().catch(() => {})
      else video.pause()
    })
  }, { rootMargin: "160px 0px", threshold: 0.01 })

  videos.forEach(video => observer.observe(video))
})()
